export const lineHeight = {
    22: '22px',
    24: '24px',
    30: '30px'
};
